<template>
  <v-container fluid class="mt-4">
    <v-card class="shadowCard">
      <v-card-title class="text-subtitle-1 black--text d-flex flex-wrap align-center">
        <span>Validación pagos curso</span>
        <v-spacer></v-spacer>
        <v-btn small tile color="teal" dark class="mr-2" @click="dialogResumen = true">
          <v-icon left small>mdi-chart-box</v-icon>
          Resumen / Excel
        </v-btn>
        <v-btn small tile color="primary" @click="consultar" :loading="cargando">
          <v-icon left small>mdi-refresh</v-icon>
          Actualizar
        </v-btn>
      </v-card-title>

      <v-card-text>
        <v-row dense>
          <v-col cols="12" sm="6" md="2">
            <v-select
              v-model="filtros.estado"
              :items="opcionesEstado"
              label="Estado"
              filled
              dense
              hide-details
              clearable
            ></v-select>
          </v-col>
          <v-col cols="12" sm="6" md="2">
            <v-select
              v-model="filtros.curso_id"
              :items="cursos"
              item-text="curso_nombre"
              item-value="curso_id"
              label="Curso"
              filled
              dense
              hide-details
              clearable
            ></v-select>
          </v-col>
          <v-col cols="12" sm="6" md="2">
            <v-select
              v-model="filtros.nivel_id"
              :items="nivelesFiltrados"
              item-text="nivel_nombre"
              item-value="nivel_id"
              label="Nivel"
              filled
              dense
              hide-details
              clearable
            ></v-select>
          </v-col>
          <v-col cols="6" sm="3" md="2">
            <v-text-field
              v-model="filtros.fecha_desde"
              label="Desde"
              type="date"
              filled
              dense
              hide-details
            ></v-text-field>
          </v-col>
          <v-col cols="6" sm="3" md="2">
            <v-text-field
              v-model="filtros.fecha_hasta"
              label="Hasta"
              type="date"
              filled
              dense
              hide-details
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="2">
            <v-text-field
              v-model="filtros.busqueda"
              label="Matrícula / alumno"
              filled
              dense
              hide-details
              clearable
              prepend-inner-icon="mdi-magnify"
              @keyup.enter="consultar"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-data-table
          class="mt-4"
          dense
          :headers="headers"
          :items="pagos"
          :loading="cargando"
          item-key="pago_id"
          :items-per-page="25"
        >
          <template v-slot:item.monto="{ item }">
            {{ formatMonto(item.monto) }} {{ item.moneda }}
          </template>
          <template v-slot:item.fecha_pago="{ item }">
            {{ formatFecha(item.fecha_pago) }}
          </template>
          <template v-slot:item.estado="{ item }">
            <v-chip x-small label :color="colorEstado(item.estado)" dark>
              {{ item.estado }}
            </v-chip>
            <v-chip
              v-if="item.es_vigente"
              x-small
              label
              outlined
              color="primary"
              class="ml-1"
            >vigente</v-chip>
          </template>
          <template v-slot:item.antiguedad="{ item }">
            <span :class="{ 'red--text font-weight-bold': esViejoPendiente(item) }">
              {{ textoAntiguedad(item) }}
            </span>
            <v-chip
              v-if="esViejoPendiente(item)"
              x-small
              color="error"
              dark
              class="ml-1"
            >+24h</v-chip>
          </template>
          <template v-slot:item.acciones="{ item }">
            <v-btn icon small color="primary" @click="abrirDetalle(item)">
              <v-icon small>mdi-eye</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <!-- Detalle -->
    <v-dialog v-model="dialogDetalle" max-width="900" scrollable>
      <v-card v-if="pagoActivo">
        <v-card-title class="text-subtitle-1">
          {{ pagoActivo.matricula }} · {{ pagoActivo.nombre_alumno }}
          <v-spacer></v-spacer>
          <v-btn icon @click="dialogDetalle = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" md="5">
              <div class="mb-2"><b>Curso:</b> {{ pagoActivo.curso_nombre }}</div>
              <div class="mb-2"><b>Nivel:</b> {{ pagoActivo.nivel_nombre }}</div>
              <div class="mb-2"><b>Monto:</b> {{ formatMonto(pagoActivo.monto) }} {{ pagoActivo.moneda }}</div>
              <div class="mb-2"><b>Fecha pago:</b> {{ formatFecha(pagoActivo.fecha_pago) }}</div>
              <div class="mb-2"><b>Estado:</b> {{ pagoActivo.estado }}</div>
              <div v-if="pagoActivo.motivo" class="mb-2"><b>Motivo:</b> {{ pagoActivo.motivo }}</div>

              <v-textarea
                v-if="puedeDecidir"
                v-model="motivoRechazo"
                label="Motivo de rechazo"
                filled
                dense
                rows="2"
                hide-details
                class="mt-3"
              ></v-textarea>

              <div v-if="puedeDecidir" class="mt-3 d-flex">
                <v-btn color="success" small tile class="mr-2" :loading="guardando" @click="aprobar">
                  Aprobar
                </v-btn>
                <v-btn color="error" small tile outlined :loading="guardando" @click="rechazar">
                  Rechazar
                </v-btn>
              </div>
            </v-col>
            <v-col cols="12" md="7">
              <div v-if="esImagen(pagoActivo.comprobante_url)" class="comprobante-box">
                <img :src="pagoActivo.comprobante_url" alt="Comprobante" class="comprobante-img" />
              </div>
              <iframe
                v-else
                :src="pagoActivo.comprobante_url"
                class="comprobante-frame"
                title="Comprobante"
              ></iframe>
              <div class="mt-2">
                <a :href="pagoActivo.comprobante_url" target="_blank" rel="noopener">Abrir en pestaña</a>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Resumen / export -->
    <v-dialog v-model="dialogResumen" max-width="640">
      <v-card>
        <v-card-title class="text-subtitle-1">
          Resumen por rango
          <v-spacer></v-spacer>
          <v-btn icon @click="dialogResumen = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-text>
          <v-row dense>
            <v-col cols="6">
              <v-text-field v-model="resumen.fecha_desde" type="date" label="Desde" filled dense hide-details></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field v-model="resumen.fecha_hasta" type="date" label="Hasta" filled dense hide-details></v-text-field>
            </v-col>
          </v-row>
          <v-btn small tile color="primary" class="mt-3" :loading="cargandoResumen" @click="cargarResumen">
            Calcular
          </v-btn>

          <div v-if="resumenData" class="mt-4">
            <div><b>Cantidad:</b> {{ resumenData.cantidad }}</div>
            <div><b>Suma total:</b> {{ formatMonto(resumenData.suma_total) }} MXN</div>
            <div class="mt-2"><b>Por estado:</b></div>
            <ul class="mb-2">
              <li v-for="(n, est) in resumenData.por_estado" :key="est">{{ est }}: {{ n }}</li>
            </ul>
            <div><b>Por curso / nivel:</b></div>
            <ul>
              <li v-for="(r, i) in resumenData.por_curso_nivel" :key="i">
                {{ r.curso_nombre }} / {{ r.nivel_nombre }} — {{ r.cantidad }} — {{ formatMonto(r.monto) }}
              </li>
            </ul>
            <v-btn small tile color="green" dark class="mt-2" @click="exportarExcelResumen">
              <v-icon left small>mdi-microsoft-excel</v-icon>
              Exportar a Excel
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <Alerta v-if="respuestaAlerta" :parametros="parametros" />
  </v-container>
</template>

<script>
import Alerta from '@/components/alertas/Alerta.vue'
import validarErrores from '@/mixins/validarErrores'
import funcionesExcel from '@/mixins/funcionesExcel'

export default {
  name: 'ValidacionPagosCurso',
  components: { Alerta },
  mixins: [validarErrores, funcionesExcel],
  data: function () {
    return {
      cargando: false,
      guardando: false,
      cargandoResumen: false,
      pagos: [],
      cursos: [],
      niveles: [],
      filtros: {
        estado: null,
        curso_id: null,
        nivel_id: null,
        fecha_desde: null,
        fecha_hasta: null,
        busqueda: '',
      },
      opcionesEstado: [
        { text: 'pendiente', value: 'pendiente' },
        { text: 'en_revision', value: 'en_revision' },
        { text: 'aprobado', value: 'aprobado' },
        { text: 'rechazado', value: 'rechazado' },
      ],
      headers: [
        { text: 'Matrícula', value: 'matricula' },
        { text: 'Alumno', value: 'nombre_alumno' },
        { text: 'Curso', value: 'curso_nombre' },
        { text: 'Nivel', value: 'nivel_nombre' },
        { text: 'Monto', value: 'monto' },
        { text: 'Fecha pago', value: 'fecha_pago' },
        { text: 'Estado', value: 'estado' },
        { text: 'Antigüedad', value: 'antiguedad', sortable: false },
        { text: '', value: 'acciones', sortable: false, width: '56px' },
      ],
      dialogDetalle: false,
      pagoActivo: null,
      motivoRechazo: '',
      dialogResumen: false,
      resumen: { fecha_desde: '', fecha_hasta: '' },
      resumenData: null,
      parametros: { dialogError: false, mensaje: '', color: '' },
      respuestaAlerta: false,
    }
  },
  computed: {
    nivelesFiltrados: function () {
      if (!this.filtros.curso_id) return this.niveles
      return this.niveles.filter((n) => n.curso_id === this.filtros.curso_id)
    },
    puedeDecidir: function () {
      if (!this.pagoActivo) return false
      return ['pendiente', 'en_revision'].indexOf(this.pagoActivo.estado) !== -1
    },
  },
  created: function () {
    this.cargarCatalogos()
    this.consultar()
  },
  methods: {
    formatMonto: function (v) {
      var n = Number(v)
      if (!Number.isFinite(n)) return v
      return n.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    },
    formatFecha: function (v) {
      if (!v) return ''
      var d = new Date(v)
      if (Number.isNaN(d.getTime())) return String(v)
      return d.toLocaleString('es-MX')
    },
    colorEstado: function (estado) {
      if (estado === 'aprobado') return 'success'
      if (estado === 'rechazado') return 'error'
      if (estado === 'en_revision') return 'orange'
      return 'blue-grey'
    },
    horasDesde: function (item) {
      var t = new Date(item.created_at || item.fecha_pago).getTime()
      if (!Number.isFinite(t)) return 0
      return (Date.now() - t) / 3600000
    },
    esViejoPendiente: function (item) {
      return item.estado === 'pendiente' && this.horasDesde(item) > 24
    },
    textoAntiguedad: function (item) {
      var h = this.horasDesde(item)
      if (h < 1) return Math.round(h * 60) + ' min'
      if (h < 48) return Math.round(h) + ' h'
      return Math.round(h / 24) + ' d'
    },
    esImagen: function (url) {
      return /\.(png|jpe?g|gif|webp|bmp)(\?|$)/i.test(String(url || ''))
    },
    cargarCatalogos: function () {
      var self = this
      this.$http.post('pagos.curso.catalogos', {}).then(function (r) {
        self.cursos = (r.data && r.data.cursos) || []
        self.niveles = (r.data && r.data.niveles) || []
      }).catch(function () {})
    },
    consultar: function () {
      var self = this
      this.cargando = true
      this.$http
        .post('pagos.curso.list', Object.assign({}, this.filtros))
        .then(function (r) {
          self.pagos = (r.data && r.data.pagos) || []
        })
        .catch(function (e) {
          self.validarError((e.response && e.response.data && e.response.data.message) || 'Error al listar')
        })
        .finally(function () {
          self.cargando = false
        })
    },
    abrirDetalle: function (item) {
      var self = this
      this.motivoRechazo = ''
      this.pagoActivo = item
      this.dialogDetalle = true
      if (item.estado === 'pendiente') {
        this.$http
          .post('pagos.curso.marcar-revision', { pago_id: item.pago_id })
          .then(function (r) {
            if (r.data && r.data.pago) {
              self.pagoActivo = r.data.pago
              self.consultar()
            }
          })
          .catch(function () {})
      }
    },
    aprobar: function () {
      var self = this
      this.guardando = true
      this.$http
        .post('pagos.curso.aprobar', { pago_id: this.pagoActivo.pago_id })
        .then(function (r) {
          self.pagoActivo = r.data.pago
          self.parametros = { dialogError: true, mensaje: 'Pago aprobado', color: 'success' }
          self.respuestaAlerta = true
          self.consultar()
        })
        .catch(function (e) {
          self.validarError((e.response && e.response.data && e.response.data.message) || 'No se pudo aprobar')
        })
        .finally(function () {
          self.guardando = false
        })
    },
    rechazar: function () {
      var self = this
      if (!String(this.motivoRechazo || '').trim()) {
        return this.validarErrorDirecto('El motivo es obligatorio para rechazar')
      }
      this.guardando = true
      this.$http
        .post('pagos.curso.rechazar', {
          pago_id: this.pagoActivo.pago_id,
          motivo: this.motivoRechazo,
        })
        .then(function (r) {
          self.pagoActivo = r.data.pago
          self.parametros = { dialogError: true, mensaje: 'Pago rechazado', color: 'success' }
          self.respuestaAlerta = true
          self.consultar()
        })
        .catch(function (e) {
          self.validarError((e.response && e.response.data && e.response.data.message) || 'No se pudo rechazar')
        })
        .finally(function () {
          self.guardando = false
        })
    },
    cargarResumen: function () {
      var self = this
      if (!this.resumen.fecha_desde || !this.resumen.fecha_hasta) {
        return this.validarErrorDirecto('Indica el rango de fechas')
      }
      this.cargandoResumen = true
      this.$http
        .post('pagos.curso.resumen', {
          fecha_desde: this.resumen.fecha_desde + ' 00:00:00',
          fecha_hasta: this.resumen.fecha_hasta + ' 23:59:59',
        })
        .then(function (r) {
          self.resumenData = r.data
        })
        .catch(function (e) {
          self.validarError((e.response && e.response.data && e.response.data.message) || 'Error resumen')
        })
        .finally(function () {
          self.cargandoResumen = false
        })
    },
    exportarExcelResumen: function () {
      if (!this.resumenData || !(this.resumenData.pagos || []).length) {
        return this.validarErrorDirecto('No hay pagos en el rango')
      }
      var filas = (this.resumenData.pagos || []).map(function (p) {
        return {
          Matrícula: p.matricula,
          Alumno: p.nombre_alumno,
          'Curso ID': p.curso_id,
          Curso: p.curso_nombre,
          'Nivel ID': p.nivel_id,
          Nivel: p.nivel_nombre,
          Monto: Number(p.monto),
          Moneda: p.moneda,
          'Fecha pago': p.fecha_pago,
          Estado: p.estado,
          Motivo: p.motivo || '',
          'Pago ID': p.pago_id,
          'Creado en': p.created_at,
          'Actualizado en': p.updated_at,
          'Validado en': p.validado_en || '',
          Vigente: p.es_vigente ? 'Sí' : 'No',
        }
      })
      var suma = filas.reduce(function (acc, f) {
        return acc + (Number(f.Monto) || 0)
      }, 0)
      filas.push({
        Matrícula: 'TOTALES',
        Alumno: '',
        'Curso ID': '',
        Curso: '',
        'Nivel ID': '',
        Nivel: '',
        Monto: Math.round(suma * 100) / 100,
        Moneda: 'MXN',
        'Fecha pago': '',
        Estado: 'N=' + (filas.length),
        Motivo: '',
        'Pago ID': '',
        'Creado en': '',
        'Actualizado en': '',
        'Validado en': '',
        Vigente: '',
      })
      this.exportExcel(filas, 'pagos_curso_' + this.resumen.fecha_desde + '_' + this.resumen.fecha_hasta)
    },
  },
}
</script>

<style scoped>
.comprobante-box {
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 8px;
  overflow: auto;
  max-height: 480px;
}
.comprobante-img {
  max-width: 100%;
  display: block;
}
.comprobante-frame {
  width: 100%;
  height: 480px;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 8px;
}
</style>
